import { useScrollToTop } from '@/hooks/useScrollToTop';

/**
 * Component that handles scroll behavior on route changes.
 * Must be placed inside BrowserRouter.
 */
const ScrollManager = () => {
  useScrollToTop();
  return null;
};

export default ScrollManager;
